import Vue from 'vue'
import Router from 'vue-router'
import Records from '../components/Records.vue'
import RecordEdit from '../components/RecordEdit.vue'
import RecordsList from '../components/RecordsList.vue'
import Login from '../components/Login.vue'
import moment from 'moment'
import auth from './../auth'

Vue.use(Router)

function requireAuth (to, from, next) {
  if (!auth.hasToken()) {
    next({
      name: 'Login'
    })
  } else {
    next()
  }
}

export default new Router({
  routes: [
    {
      name: 'Home',
      path: '/',
      redirect: () => {
        return {
          name: 'Records',
          params: {
            slug: moment().format('YYYY-MM-DD')
          }
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (auth.hasToken()) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/records/:slug/',
      component: Records,
      props: true,
      beforeEnter: requireAuth,
      children: [
        {
          path: '',
          name: 'Records',
          component: RecordsList,
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: ':id/edit',
          name: 'RecordEdit',
          component: RecordEdit,
          props: true,
          beforeEnter: requireAuth
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js